import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/supabaseClient';
import { toast } from 'sonner';
import posthog from 'posthog-js';

export function useLogout() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async () => {
			const { error } = await supabase.auth.signOut();
			if (error) throw error;
		},
		onMutate: () =>
			toast.loading('Logging out...', {
				description: 'Please wait while we securely log you out.',
			}),
		onSuccess: (_data, _variables, context) => {
			queryClient.clear();
			posthog.reset();
			if (context) toast.dismiss(context);
		},
		onError: (error: Error, _variables, context) => {
			if (context) toast.dismiss(context);
			toast.error('Logout failed', {
				description: error.message || 'An unexpected error occurred.',
			});
		},
	});
}
